// Validación de las imágenes de salas ANTES de enviarlas al backend.
//
// El backend normaliza toda imagen a WebP optimizado (redimensiona y baja el
// peso sin pérdida visible), así que aquí no se convierte nada: solo se filtra
// lo que no tiene sentido subir. La conversión real vive en
// elhubsvoffice_back/src/helpers/imageProcessing.ts — mantener ambas listas
// alineadas.

/** Formatos que el backend sabe convertir a WebP. */
export const ACCEPTED_IMAGE_EXTENSIONS = [
  'jpg', 'jpeg', 'png', 'webp', 'gif', 'avif', 'tif', 'tiff', 'heic', 'heif',
];

/** RAW: no se puede procesar en el servidor y el navegador no lo muestra. */
export const RAW_IMAGE_EXTENSIONS = [
  'cr2', 'cr3', 'nef', 'nrw', 'arw', 'sr2', 'srf', 'dng', 'raf', 'rw2',
  'orf', 'srw', 'pef', 'x3f', 'raw', 'rwl', 'iiq', '3fr', 'fff', 'mos', 'mrw',
];

/** Tamaño máximo del archivo original (la salida WebP pesa mucho menos). */
export const MAX_IMAGE_UPLOAD_BYTES = 30 * 1024 * 1024;
export const MAX_IMAGE_UPLOAD_MB = 30;

/** Valor del atributo `accept` del <input type="file">. */
export const IMAGE_UPLOAD_ACCEPT =
  ACCEPTED_IMAGE_EXTENSIONS.map((ext) => `.${ext}`).join(',') +
  ',image/jpeg,image/png,image/webp,image/gif,image/avif,image/tiff,image/heic,image/heif';

const extensionOf = (fileName: string): string =>
  (fileName.split('.').pop() || '').toLowerCase();

/**
 * Revisa un conjunto de archivos. Devuelve `null` si todos son válidos, o el
 * mensaje de error del primer archivo que falla (ya redactado para el usuario).
 */
export const validateSpaceImages = (files: File[]): string | null => {
  for (const file of files) {
    const ext = extensionOf(file.name);

    if (RAW_IMAGE_EXTENSIONS.includes(ext)) {
      return `"${file.name}" está en formato RAW y no se puede subir. Expórtala como JPG, PNG o TIFF desde tu editor de fotos.`;
    }
    if (!ACCEPTED_IMAGE_EXTENSIONS.includes(ext)) {
      return `El formato de "${file.name}" no se admite. Usa JPG, PNG, WebP, GIF, TIFF, AVIF o HEIC.`;
    }
    if (file.size === 0) {
      return `"${file.name}" está vacío o dañado.`;
    }
    if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
      return `"${file.name}" supera el límite de ${MAX_IMAGE_UPLOAD_MB} MB.`;
    }
  }
  return null;
};
